import * as React from 'react'
import PropTypes from 'prop-types'
import './Hemicycle.css'
// import * as d3 from 'd3'
// import { TweenMax, Bounce } from 'gsap'

class Hemicycle extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      mobile: false
    }
  }

  renderHemicycle (props) {
    if (window.innerWidth < 800) {
      console.log('Small device')
      this.setState({
        mobile: true
      })
    } else {
      this.setState({
        mobile: false
      })
    }
  }

  componentDidMount () {
    if (window.innerWidth < 800) {
      console.log('Small device')
      this.mobile = true

      this.setState({
        mobile: true
      })
    }

    console.log('Mount hemicycle')
    window.addEventListener('resize', this.renderHemicycle.bind(this))
  }

  render () {
    return (
      <div className='ui container'>
        <img
          src={require('./images/ch_grid_' +
            this.props.mapId +
            (this.state.mobile ? '-mobile' : '') +
            '.png')}
        />
      </div>
    )
  }
}

Hemicycle.propTypes = {
  mapId: PropTypes.number
}

export default Hemicycle



// WEBPACK FOOTER //
// ./src/components/main/Hemicycle.js